/**
 * DefectDrawer 기본 결함 사각형 (열화상 패널 표시 영역 기준 픽셀).
 * 우선순위: solarRgbImages 조회 메타 → 없으면 아래 기본값 (세로 70 × 가로 35 직사각형).
 *
 * Vuex `defect.defectShapes` 초기값·RESET_DEFAULT_RECT 과 반드시 동기화한다.
 */
export const DEFECT_DRAWER_VIEW_W = 640;
export const DEFECT_DRAWER_VIEW_H = 512;

export const DEFAULT_DEFECT_RECT_W = 35;
export const DEFAULT_DEFECT_RECT_H = 70;

/** reset({}) 시 중앙 배치용 좌상단 */
export const DEFAULT_DEFECT_RECT_X = Math.round(
  (DEFECT_DRAWER_VIEW_W - DEFAULT_DEFECT_RECT_W) / 2
);
export const DEFAULT_DEFECT_RECT_Y = Math.round(
  (DEFECT_DRAWER_VIEW_H - DEFAULT_DEFECT_RECT_H) / 2
);

/** Vuex `defect.defectShapes` 초기값·RESET_DEFAULT_RECT 공통 팩토리 */
export function createDefaultDefectShapes() {
  return {
    x: DEFAULT_DEFECT_RECT_X,
    y: DEFAULT_DEFECT_RECT_Y,
    width: DEFAULT_DEFECT_RECT_W,
    height: DEFAULT_DEFECT_RECT_H,
    reportId: null
  };
}
